import { Box } from '@mui/material'
import { keys } from 'lodash-es'
import React from 'react'
import {
    POSVariantOptionWithPrice,
    UsedVariants,
} from 'store/models/sellModels'
import { useCartContext } from './CartContext'
import { DisplayLine } from './CartItemDetail'

interface CartVariantOptionRowProps {
    usedVariants: UsedVariants
    comboVariantOptions?: POSVariantOptionWithPrice[]
    itemQuantity?: number
    isOrderLineVoided?: boolean
}
export const CartVariantOptionRow = ({
    usedVariants,
    comboVariantOptions = [],
    itemQuantity = 1,
    isOrderLineVoided = false,
}: CartVariantOptionRowProps) => {
    const { variantGroupsMap } = useCartContext()
    return (
        <>
            {keys(usedVariants).map((g, idx) => {
                const option:
                    | POSVariantOptionWithPrice
                    | undefined = comboVariantOptions.find(
                    (o) => o.variantOptionID === usedVariants[g],
                ) ?? {
                    ...variantGroupsMap[g]?.variantOptions?.find(
                        (o) => o.variantOptionID === usedVariants[g],
                    ),
                    addPrice: 0,
                    isDefaultOption: false,
                }

                return (
                    <Box key={`${idx}-option-cart-item-display`}>
                        <DisplayLine
                            name={option?.name || '-'}
                            price={(option?.addPrice ?? 0) * itemQuantity}
                            hidePrice={isOrderLineVoided}
                        />
                    </Box>
                )
            })}
        </>
    )
}
